var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMillustrationsLightstep = function SvgMillustrationsLightstep(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.04,
    d: "M0 2a2 2 0 0 1 2-2h52a2 2 0 0 1 2 2v36a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 23,
    x: 8.5,
    y: 8.5,
    fill: "#fff",
    stroke: "#CCCCD9",
    rx: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8A8A99",
    fillRule: "evenodd",
    d: "m21.976 17.584 5.555-2.978c.034-.023.08-.034.103-.011l7.25.423h.022c.069.012.103.08.092.138l-1.718 7.696a.22.22 0 0 1-.126.16l-4.638 2.107a.3.3 0 0 1-.195 0l-7.26-3.424c-.047-.023-.07-.069-.058-.126l.859-3.836a.24.24 0 0 1 .114-.15m-.217 4.122 6.62 3.116 1.27-2.325-5.531-.79zm10.914 1.215-2.726-.39-1.19 2.176zm-6.23-5.59-2.096 4.124 5.451.778 3.104-5.646zm.137-.286 6.517-.756 1.374-1.03-6.78-.401zm-3.87.447 3.55-.412 1.042-2.039zm3.4-.114-3.996.458-.802 3.596h2.737zm3.975 4.901 2.954.424 1.615-7.227-1.397 1.042zm-.344-2.428a1.718 1.718 0 1 1-3.436 0 1.718 1.718 0 0 1 3.436 0",
    clipRule: "evenodd"
  })));
};
export default SvgMillustrationsLightstep;